// extracted by mini-css-extract-plugin
module.exports = {"main":"Home_main__2UuYP"};